import { errorStatus, isRbacStoreOutage } from "./api-error";

/**
 * #3319 RETRY403: is a failed query worth sending again?
 *
 * A 4xx is the server's answer about THIS request (not signed in, not your
 * role, no such row, bad input), so resending it cannot succeed; it only
 * doubles the console error on every page a role cannot fully read. Two 4xx
 * statuses do mean "try again": 408 (timed out) and 429 (slow down). The RBAC
 * store's fail-closed 403 (#327, isRbacStoreOutage) is a D1 blip wearing a
 * 403, so it stays retryable like any other fault. 5xx, network errors and
 * anything without a status are retryable.
 */
export function isRetryableError(error: unknown): boolean {
  const status = errorStatus(error);
  if (status === undefined || status < 400 || status >= 500) return true;
  if (status === 408 || status === 429) return true;
  return isRbacStoreOutage(error);
}

/** A react-query `retry` predicate: up to `maxRetries` resends, faults only. */
export function retryFaults(maxRetries: number) {
  return (failureCount: number, error: unknown): boolean =>
    failureCount < maxRetries && isRetryableError(error);
}

/** The app default (lib/query-client.ts): one resend, never for a settled 4xx. */
export const shouldRetryQuery = retryFaults(1);
